import PropTypes from 'prop-types'
import { forwardRef } from 'react'

const SectionsListItem = forwardRef((
  { focusable, section: { level, title }, hidden }, ref) => {

  return (
    <li
      className={[
        'table-of-contents__section',
        'table-of-contents__level-',
        level
      ].join(' ')}
      hidden={hidden}
      {...(ref ? { ref } : {})}
      // eslint-disable-next-line
      tabIndex={focusable ? 0 : undefined}
    >
      {title}
    </li>
  )
})
export default SectionsListItem
SectionsListItem.propTypes = {
  focusable: PropTypes.bool.isRequired,
  hidden: PropTypes.bool.isRequired,
  section: PropTypes.shape({
    level: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired
  })
}
